import React, { useState } from "react";

import "../mobileSettings.css";

import EditIcon from "../../../assets/icon/Edit.svg";
import EditAddressModal from "./EditAddressModal";
import EditNameModal from "./EditNameModal";
// import UserIcon from "../../../assets/icon/Profile.svg";

const UserInfoItems = ({
  userInfoIcon,
  userInfoTitle,
  userInfoText,
  IconShow,
  editType,
  smallContent,
}) => {
  let editIconShow = IconShow;

  return (
    <div className="mobileSettings-userInfo-item">
      <div className="mobileSettings-userInfo-item-wrapper">
        <div className="userInfo-item-icon">
          <img src={userInfoIcon} alt="icon" />
        </div>
        <div className="userInfo-item-wrapper">
          <p className="userInfo-item-title">{userInfoTitle}</p>
          <p
            className={
              smallContent ? "userInfo-item-text-small" : "userInfo-item-text"
            }
          >
            {userInfoText}
          </p>
        </div>
      </div>
      <div className="mobileSettings-userInfo-edit-wrapper">
        {editIconShow === true ? <div> {editType}</div> : ""}
      </div>
    </div>
  );
};

export default UserInfoItems;
